<template>
    <div class="accordion accordion_box">
<!--        <div class="overflow point_hiden" v-if="category==='カーテン'">近日公開</div>-->
        <div @click="is_active=!is_active">{{category}}&nbsp;<span class="open_mark">▼</span></div>
        <div style="padding-left: 1rem; margin-top: 0.3rem;"
             v-bind:class="{accordion_onoff:is_active}"
             v-for="(item, key) in $store.state.xlsx_data.style_group2_data[category]"
        >

            <div v-if="category===key">
                <div class="style_button"
                     v-for="(style_data, index) in $store.state.xlsx_data.style_group2_data[category][key]"
                >
                    <input type="radio"
                           v-bind:id="'style_'+style_data.style_id"
                           v-model="style_selected"
                           v-bind:value="style_data.style_id"
                           v-bind:disabled="$store.state.search_data[style_data.style]=='×'"
                    >
<!--                    {{$store.state.search_data[style_data.style]}}:-->
                    <label class="col01"
                           v-bind:for="'style_'+style_data.style_id"
                           v-bind:class="{disabled_label:$store.state.search_data[style_data.style]=='×'}"
                           v-on:click="no_select_rule(style_data.style,$store.state.search_data)"
                    >
                        <img v-if="style_data.svg===undefined" class="svg_icon" v-bind:src="[style_selected==style_data.style_id ? './assets/images/blank_o.svg' : './assets/images/blank.svg']">
                        <img v-else class="svg_icon" v-bind:src="[style_selected===style_data.style_id ? './assets/images/'+style_data.svg+'_o.svg' : './assets/images/'+style_data.svg+'.svg']">
<!--                        <span class="svg_icon" v-html="svg_html[style_data.svg]"></span>-->
                        <p v-if="style_data.name==='スタンダード縫製'" class="style_name">カーテン<br>形態安定加工なし</p>
                        <p v-else-if="style_data.name==='ソフトウェーブ縫製'" class="style_name">カーテン<br>形態安定加工付</p>
                        <p v-else-if="style_data.name==='ファインウェーブ縫製'" class="style_name">カーテン<br><span style="font-size: 0.6rem;">上級形態安定加工付</span></p>
                        <p v-else class="style_name">{{style_data.name}}</p>
                    </label>
                </div>
            </div>
            <div style="clear:both;" v-else>
                <accordion3
                        v-bind:category="category"
                        v-bind:key_name="key"
                />
            </div>
        </div>

    </div>
</template>

<script>
    //import accordion2 from './Accordion2.vue'
    import accordion3 from './Accordion3.vue'

    export default {
        name: "Accordion",
        components: {
            accordion3
        },
        props: {
            category : String,
        },
        computed: {
            style_selected: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_id
                },
                set: function (value) {
                    this.$store.commit('updateStyleSelected1', value)
                    //this.$store.dispatch('priceCheck')
                }
            },
            group1_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected1_id !== ''){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                    }
                    return ''
                },
            },
            group2_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                    }
                    return ''
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }
                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            item_data:{
                get: function () {
                    if(this.$store.state.xlsx_data.item_data && this.atomaku_number !=='' && typeof(this.$store.state.xlsx_data.item_data['FT'+this.atomaku_number]) !== 'undefined'){
                        return this.$store.state.xlsx_data.item_data['FT'+this.atomaku_number]
                    }
                    return ''
                },
            }
        },
        data() {
            return {
                svg_html:{},
                is_active:true
            }
        },
        created : function () {
        },
        mounted: function () {
            if(this.category==='クッション'){
                //alert('完了！')
                this.$store.commit('updateLoading', false)
            }
        },
        methods:{
            changeIcon: function(){
                //console.log()
            },
            /**
             * 対応不可理由の更新処理
             * @param style_name
             * @param style_result
             */
            no_select_rule : function(style_name,style_result){
                const item_num = this.$store.state.step1_data.item_number
                const no_select_data = this.$store.state.xlsx_data.no_select_result['FT'+item_num]

                if(style_result[style_name]=='×'){
                    //対応不可理由の更新
                    this.$store.state.now_no_select_result = no_select_data[style_name]
                    this.showModal()
                }
            },
            showModal() {
                this.$root.$emit('bv::show::modal', 'modal-2', '#btnShow')
            },
            load_svg: function(_file_name){
                const req = new XMLHttpRequest()
                req.open('GET', './assets/images/'+_file_name, true)
                req.responseType = 'text'
                const scope = this

                //ローディングをつける　TODO
                req.onload = function () {
                    if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                        return false
                    }
                    //データを処理
                    //document.getElementById("living").appendChild( req.responseXML )
                    scope.svg_html[_file_name] = req.responseText
                }
                req.onerror = function() {
                    return false
                }
                req.send();
            },
        }

    }
</script>

<style scoped>
    .accordion_onoff{
        display: none;
    }
    .point_hiden{
        height: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        color: #fff;
        font-weight: bold;
        text-align: center;
        vertical-align: middle;
        line-height: 40px;
    }
</style>e